import { Toaster } from "@/components/ui/toaster";
import queryClient from "@/shared/lib/queryClient";
import "@/shared/styles/globals.css";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import type { AppProps } from "next/app";
import { Inter } from "next/font/google";
import Head from "next/head";
import { PagesTopLoader } from "nextjs-toploader/pages";

const inter = Inter({
	variable: "--font-sans",
	subsets: ["latin"],
	weight: ["100", "300", "400", "500", "700", "800", "900"],
	style: ["normal", "italic"],
	display: "swap",
});

export default function App({ Component, pageProps }: AppProps) {
	return (
		<>
			<Head>
				<link
					rel="icon"
					href="https://res.cloudinary.com/du6njjxvi/image/upload/v1758085553/favicon_ou6wpo.ico"
				/>
			</Head>
			<QueryClientProvider client={queryClient}>
				<ReactQueryDevtools initialIsOpen={false} />
				<div className={inter.variable}>
					<PagesTopLoader color="#52c64c" showSpinner={false} />
					<Component {...pageProps} />
					<Toaster position="top" />
				</div>
			</QueryClientProvider>
		</>
	);
}
